export default __webpack_public_path__ + "static/trees-6ebb439adb9580839ab5101b969b13c7.gif";